type RegionCode = 'sa' | 'ae' | 'eg';

type RegionStatus = 'reachable' | 'blocked' | 'error' | 'unknown';

import './RegionalBadges.css';

const REGION_LABELS: Record<RegionCode, string> = {
  sa: 'SA',
  ae: 'AE',
  eg: 'EG',
};

const REGION_DESCRIPTIONS: Record<RegionCode, string> = {
  sa: 'Saudi Arabia',
  ae: 'United Arab Emirates',
  eg: 'Egypt',
};

const STATUS_META: Record<RegionStatus, { symbol: string; description: string }> = {
  reachable: { symbol: '✓', description: 'Reachable (proxy success)' },
  blocked: { symbol: '✗', description: 'Blocked (proxy unreachable)' },
  error: { symbol: '!', description: 'Error (proxy failed)' },
  unknown: { symbol: '?', description: 'Unknown (no data yet)' },
};

export function normalizeRegionStatus(value: string | undefined | null): RegionStatus {
  if (!value) return 'unknown';
  const lower = value.toLowerCase();
  if (lower === 'reachable') return 'reachable';
  if (lower === 'blocked') return 'blocked';
  if (lower === 'error') return 'error';
  return 'unknown';
}

interface RegionalBadgesProps {
  statusMap: Partial<Record<RegionCode, string | undefined>>;
  size?: 'default' | 'compact';
  className?: string;
}

export default function RegionalBadges({ statusMap, size = 'default', className }: RegionalBadgesProps) {
  return (
    <div className={`regional-badges ${size} ${className || ''}`.trim()}>
      {(Object.keys(REGION_LABELS) as RegionCode[]).map((code) => {
        const status = normalizeRegionStatus(statusMap[code]);
        const { symbol, description } = STATUS_META[status];
        const label = REGION_LABELS[code];
        const regionName = REGION_DESCRIPTIONS[code];
        const title = `${regionName}: ${description}`;
        return (
          <span key={code} className={`regional-badge ${status}`} title={title}>
            {label} {symbol}
          </span>
        );
      })}
    </div>
  );
}

export type { RegionCode, RegionStatus };
